import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SpinnerService } from '../../shared/services/shared/spinner/spinner.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-client-redirect',
  imports: [],
  templateUrl: './client-redirect.component.html',
  styleUrl: './client-redirect.component.scss',
})
export class ClientRedirectComponent implements OnInit {
  constructor(
    private _spinnerService: SpinnerService,
    private _route: ActivatedRoute,
  ) {}

  public ngOnInit(): void {
    this._spinnerService.show('Redirecting...');

    const org = this._route.snapshot.queryParamMap.get('org');
    const token = this._route.snapshot.queryParamMap.get('token');

    if (!org || !token) {
      this._spinnerService.hide();
      // TODO: Navigate to an error page
      return;
    }
    let domain = environment.production ? 'clfx.in' : 'learnedparrot.in';
    let url = `https://${org}.${domain}/your-bookings/${token}`;
    window.location.replace(url);
  }
}
